import View from "../View";

export default class ProxyView extends View {
    constructor($el) {
        super();
        this.$el = $el;
    }
}


// WEBPACK FOOTER //
// ./web/js/util/ProxyView.js